<template>

  <div class="padded">

    <el-row :gutter="18" align="bottom">
      <el-col :span="20">
        <h2><i class="fa fa-map">&nbsp;</i><org-badge /> <small class="text-muted">{{ title }}</small>&nbsp;<el-button type="outline" circle icon="fa fa-sync" @click="resetFilter" /></h2>
      </el-col>

      <el-col v-if="isTelco()" :span="4" align="right">
        <request-action button-size="small" type="RTS" />
      </el-col>
      <el-col v-if="isBackhaulCo()" :span="4" align="right">
        <request-action button-size="small" type="RTB" />
      </el-col>

    </el-row>

    <el-form v-if="isTowerCo()" inline>

      <select-sharer
          v-model="orgId"
          full-object
          @change="sharerChange"
          size="mini"
          :disabled="!selectingSharer"
          />
        </el-col>

        <el-form-item>
          <el-button-group>
            <el-button v-if="showSelector" size="mini" type="primary" plain icon="fa fa-edit" @click="selectingSharer = !selectingSharer" />
            <el-button v-if="showSelector" size="mini" type="warning" plain icon="fa fa-times-circle" @click="resetFilter" />
          </el-button-group>

      </el-form-item>

    </el-form>

      <el-col :xs="24" :sm="24" :md="24" :lg="24">
        <component v-bind="defaultProps" :is="comp" />
      </el-col>
    </el-row>

  </div>

</template>

<script>

import SharerMap from '@/components/maps/SharerMap'

import SelectSharer from '@/components/atoms/selects/SelectSharer'
import RequestAction from '@/components/actions/RequestAction'

export default {
  components: {
    SharerMap,
    SelectSharer,
    RequestAction
  },



  methods: {

    sharerChange (value) {

      this.orgId = value.id
      this.sharerName = value.name

      this.selectingSharer = false

      this.resetComp(this.orgId)
    },


    resetFilter () {
      this.orgId = null
      this.selectingSharer = false
      this.sharerName = this.org().name

      this.resetComp(this.orgId)
    },


    resetComp (value) {
      this.defaultProps.sharer = Number(value)
    }

  },



  computed: {
    mqValue: function () {
      return this.$mq
    }

  },

  data () {
    return {
      title: 'Map',
      showSelector: this.isTowerCo(),
      orgId: this.org().orgId,
      selectingSharer: true,
      sharerName: this.org().name,
      comp: SharerMap,
      defaultProps: {
        sharer: this.isTelco() ? this.org().id : this.sharer
      }
    }
  },

  created () {

    if (this.isTelco()) {
      this.orgId = this.org().id
      this.resetComp(this.orgId)
    }

  }

}
</script>

<style scoped>
.v-modal {opacity: 0.852;}
.el-select {display: block;}
</style>
